import React from 'react';
import './JxTooltipRowItemDescription.css';

/**
 * JxTooltipRowItemDescription — één rij binnen JxTooltip-content: een label
 * links, een waarde/omschrijving rechts. Class component (i.p.v. functional)
 * zodat toekomstige varianten (JxTooltipRowDate, JxTooltipRowStatus, etc) hier
 * gewoon van kunnen extenden i.p.v. losse, ongerelateerde functies te zijn —
 * zelfde reden als andere Jx-controls.
 *
 * Modernere/Jerny-stijl versie van Kdesk's DeviceItem (6 jaar oud, functional,
 * afgekorte props t/v/c/ct) — zelfde idee (label/value/color-rij), maar
 * uitgeschreven props en geen theme-tokens-koppeling (Jx-theme via CSS vars,
 * zie JxTheme.css).
 *
 * Meerdere rijen -> wrap ze in JxTooltipRows (display:table) zodat de
 * label-kolom van alle rijen automatisch uitlijnt op de breedste label
 * (zie JxTooltipRowItemDescription.css). Eén losse rij (geen wrapper) werkt
 * ook prima — de browser genereert dan zelf een anonieme table-box.
 *
 * Gebruik: zie JxTooltipRows.jsx.
 */
class JxTooltipRowItemDescription extends React.Component {
    render() {
        const { label, value, valueColor, labelColor } = this.props;

        return (
            <div className="jx-tooltip-row">
                <span className="jx-tooltip-row-label" style={{ color: labelColor }}>
                    {label}
                </span>
                <span className="jx-tooltip-row-value" style={{ color: valueColor }}>
                    {value}
                </span>
            </div>
        );
    }
}

export default JxTooltipRowItemDescription;
